export default function VisualStudioCodeLogo() {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <title>file_type_vscode2</title>
        <path
          d="M11.72,18.685,4.837,23.869,2,22.922,9,16,2,9.077,4.837,8.13l6.883,5.184,11.433-11.3L30,4.922V27.077l-6.847,2.909ZM15.287,16l7.865,5.923V10.076Z"
          fill="#007acc"
        />
      </svg>
    </div>
  );
}
